/*eslint-disable eqeqeq */
import Formatter from '../helpers/formatter';

const gifts = {
  state: {
    gifts: [
      //{
      //id: 14,
      //user_id: 34,
      //product_id: 15,
      //created_at: "2020-04-19T19:14:45.043Z",
      //updated_at: "2020-04-19T19:14:45.043Z",
      //product: {
      //name: "Playstation Store Card $25",
      //image: "https://easi-api.herokuapp.com/assets/playstation-store-card-2500.jpg",
      //points: 2500,
      //description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      //},
      //open: true,
      //approved: false,
      //},
    ],
    isGiftListFiltered: false,
    giftListFilters: {
      timeRange: {
        //date_before: 1514764800, the number is unix epoch in seconds
        //date_after: 1514764800, the number is unix epoch in seconds
      },
      status: '' //status can be 'open','approved'
    },
    giftListPaginationInfo: {
      pageSize: 9,
      currentPage: 1,
      total: 0
    }
  },

  getters: {
    getGifts: state => () => {
      return state.gifts;
    },

    getGift: state => id => {
      return state.gifts.find(gift => gift.id == id);
    },

    isGiftListFiltered: state => () => {
      return state.isGiftListFiltered;
    },

    getGiftListFilters: state => () => {
      return state.giftListFilters;
    },

    getGiftListPaginationInfo: state => () => {
      return state.giftListPaginationInfo;
    }
  },

  mutations: {
    addGifts(state, gifts) {
      state.gifts = gifts;
    },

    addGift(state, gift) {
      state.gifts.push(gift);
    },

    updateGift(state, gift) {
      let index = state.gifts.findIndex(item => item.id === gift.id);

      if (index > -1) {
        state.gifts.splice(index, 1, gift);
      }
    },

    removeGift(state, id) {
      state.gifts = state.gifts.filter(gift => gift.id !== id);
    },

    setIsGiftListFiltered(state, payload) {
      state.isGiftListFiltered = payload;
    },

    setGiftListFilters(state, payload) {
      state.giftListFilters = Formatter.extend(state.giftListFilters, payload);
    },

    setGiftListPaginationInfo(state, payload) {
      state.giftListPaginationInfo = Formatter.extend(
        state.giftListPaginationInfo,
        payload
      );
    },

    approveGiftPurchaseRequest(state, id) {
      state.gifts.find(gift => gift.id === id).approved = true;
      state.gifts.find(gift => gift.id === id).open = false;
    },

    rejectGiftPurchaseRequest(state, id) {
      state.gifts.find(gift => gift.id === id).approved = false;
      state.gifts.find(gift => gift.id === id).open = true;
    }
  }
};

export default gifts;



// WEBPACK FOOTER //
// ./src/store/gifts.js